// extracted by mini-css-extract-plugin
module.exports = {"container":"ReviewsSummaryBar_container__SmIj3","ratingContainer":"ReviewsSummaryBar_ratingContainer__uMGZ5","rating":"ReviewsSummaryBar_rating__U4S1k"};